import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { UtilService } from 'src/app/service/util.service';
import * as CONSTANTS from '../../constants';
import { EnvironmentConfig } from '../../../environments/environmentConfig';
import * as _ from 'lodash';


@Component({
  selector: 'personal-information-preview',
  templateUrl: './personal-information-preview.component.html',
  styleUrls: ['./personal-information-preview.component.less'],
  providers: [FrameworkUtilityComponent, EnvironmentConfig]
})
export class personalInformationPreviewComponent implements OnInit {

  currentLang: string;
  enumData: any;
  currentRoutePath: string;
  preQualObj: any;
  loader: boolean = false;
  nextProgressPercent: CONSTANTS.PROGRESS_PERCENTAGE;
  mobilenumber: string;
  coMobilenumber: string;
  applicantAddressLine1: string;
  coapplicantAddressLine1: string;
  isIosDevice = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
  productFlow: any;
  applicantUserObj: any;
  coApplicantUserObj: any;
  isCoapplicantApplied: boolean;
  isExistingCustomer: boolean;
  areBothCibcCustomer: boolean;
  userVerfied: any = [];
  response: any;
   userObj = [];


  constructor(private util: UtilService, private _activatedRoute: ActivatedRoute, private formUtiObj: FrameworkUtilityComponent, private router: Router) {


    this.util.sidebarTitle.next('slideTitles.personalInfo');
    /**
     * Check if this screen is for primary or co-applicant and set the progress percentage
     */
    this.preQualObj = this.util.getSessionStorage();
    this.isCoapplicantApplied = this.preQualObj.is_coapplicant_applied == 'Y' ? true : false;
    this.isExistingCustomer = this.preQualObj.is_existing_bankcustomers == 'Y' ? true : false;
    this.areBothCibcCustomer = this.preQualObj.are_both_applicants_CIBC_customer == 'Y' ? true : false;

    let progressPercent1 = sessionStorage.getItem("progressPercentage");
    if (Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.NEW_CUSTOMER_CURRENT_ADDRESS_2_CUSTOMER || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.NEWCUSTOMER_1_PHONE || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.NEWCUSTOMER_1_AND_EXISTINGCUSTOMER1_PHONE || (sessionStorage.getItem("routeBack") == "true")) {
      let progressPrcnt = (this.preQualObj.is_coapplicant_applied == "Y") ? CONSTANTS.PROGRESS_PERCENTAGE.NEWCUSTOMER_1_EXISTINGCUSTOMER1_PERSONALINFO : CONSTANTS.PROGRESS_PERCENTAGE.NEWCUSTOMER_1_PERSONALINFO;
      if (this.preQualObj.users.length == 2) {
        if (this.preQualObj.is_existing_bankcustomers == 'Y') {
          progressPrcnt = CONSTANTS.PROGRESS_PERCENTAGE.NEWCUSTOMER_1_EXISTINGCUSTOMER1_PERSONALINFO;
        }
        else {
          progressPrcnt = CONSTANTS.PROGRESS_PERCENTAGE.JOINT_NEWCUSTOMERS_2_PERSONALINFO;
        }
        this.util.sidebarTitle.next('slideTitles.coApplicantInfo');
      }
      this.util.progressPercent.next(progressPrcnt);
      this.nextProgressPercent = progressPrcnt;
    }

    this.util.isSidebarVisible.next(true);
    this.enumData = this.util.getEnumData();
    this._activatedRoute.url.subscribe(route => {
      this.currentRoutePath = route[0].path;
    });
    this.productFlow = sessionStorage.getItem("flow");
  }
  ngOnInit(): void {
    this.preQualObj.users.forEach(obj => {
      if (obj.is_existing_bankcustomer == 'N') {
        if (obj.main_application == 0) {
          this.applicantUserObj = _.cloneDeep(obj);
        } else {
          this.coApplicantUserObj = _.cloneDeep(obj);
        }
        console.log(this.applicantUserObj, "applicantobj");
        console.log(this.coApplicantUserObj, "coapplicantuserobj");
      }
    })

    if (this.applicantUserObj) {
      if (this.applicantUserObj.homenumber.length == 10) {
        this.applicantUserObj.mobilenumber = this.applicantUserObj.homenumber.slice(0, 3)+ "-"+this.applicantUserObj.homenumber.slice(3, 6)+ "-"+ this.applicantUserObj.homenumber.slice(6);
      }
      // modifying data to display in UI
      this.applicantUserObj.address = this.applicantUserObj.addressline1 + "<br/> " + this.applicantUserObj.city + " " + this.applicantUserObj.province + "<br/>" + this.applicantUserObj.postal_code;
      // modifying data to send thro api
      this.applicantAddressLine1 = this.applicantUserObj.addressline1;

      this.applicantAddressLine1 = this.applicantAddressLine1.trim();
    }
    if (this.coApplicantUserObj) {
      if (this.coApplicantUserObj.homenumber.length == 10) {
        this.coApplicantUserObj.mobilenumber = this.coApplicantUserObj.homenumber.slice(0, 3) + "-" + this.coApplicantUserObj.homenumber.slice(3, 6) + "-" + this.coApplicantUserObj.homenumber.slice(6);
      }
      // modifying data to display in UI
      this.coApplicantUserObj.address = this.coApplicantUserObj.addressline1 + "<br/> " + this.coApplicantUserObj.city + " " + this.coApplicantUserObj.province + "<br/>" + this.coApplicantUserObj.postal_code;
      // modifying data to send thro api
      this.coapplicantAddressLine1 = this.coApplicantUserObj.addressline1 + " " + atob(sessionStorage.getItem("coapplicantAptNo"));
      this.coapplicantAddressLine1 = this.coapplicantAddressLine1.trim();
    }
    if(this.applicantUserObj!=null)
      this.userObj.push(this.applicantUserObj);
    if(this.coApplicantUserObj!=null)
    this.userObj.push(this.coApplicantUserObj);

    this.currentLang = sessionStorage.getItem("currLang")
    this.formUtiObj.InitValues();

    document.getElementById("sidebarTitle").focus();
  }

  changeTolltipValue(id: string) {
    var isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (isIos) {
      let tooltpBoxVal = document.getElementById(id).getAttribute("aria-expanded");
      if (tooltpBoxVal == "false") {
        document.getElementById(id).setAttribute('aria-expanded', 'true');
      }
      else {
        document.getElementById(id).setAttribute('aria-expanded', 'false');
      }
    }
  }
  tooltipExpandFalse() {
    var isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (isIos) {
      document.getElementById('btnttltip').setAttribute('aria-expanded', 'false');
      document.getElementById('coBtnttltip').setAttribute('aria-expanded', 'false');
    }
  }
  routeForEdit(routeUrl) {
    sessionStorage.setItem("routeBack", "true");
    let routeLink = ""
    switch (routeUrl) {
      case 'AboutYourselves':
        routeLink = 'personal-information-about-yourself';
        break;
      case 'ContactDetails':
        routeLink = 'personal-information-contact';
        break;
      case 'addressDetails':
        routeLink = 'personal-information-address';
        break;
      default:
        break;
    }

    this.router.navigate(['../' + routeLink], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' })
  }


  onContinue() {
    this.loader = true;
    this.preQualObj.users.forEach((obj, index) => {
      if (obj.is_existing_bankcustomer == 'N') {
        if (obj.main_application == 0) {
          this.preQualObj.users[index].addressline1 = this.applicantAddressLine1;
        } else {
          this.preQualObj.users[index].addressline1 = this.coapplicantAddressLine1;
        }
      }
    })
    const usersToVerify = this.preQualObj.users;
    this.verifyUsers(usersToVerify, 0);
    sessionStorage.removeItem("routeBack");
    sessionStorage.removeItem("aptNo");
    sessionStorage.removeItem("coapplicantAptNo");

  }


  verifyUsers(users: any[], index) {
    if (index >= users.length) {
      this.loader = false;
      this.saveprequalData(this.preQualObj);
      this.router.navigate([this.util.determineNextRoute("personal-information-preview")], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      return;
    }
    else {
      var user = users[index];
      if (user.is_existing_bankcustomer === CONSTANTS.applicationConstants.yesVal) {
        this.verifyUsers(users, index + 1);
        return;
      }
    }
    const reqBody = user;

    this.util.demoTransUnionResponse(reqBody, index, this.preQualObj.request_id, this.preQualObj).subscribe((resp) => {
      this.response = resp;
      if (this.response.eid_verified === true) {
        this.preQualObj.users[index]["eid_verified"] = true;
        this.preQualObj.status = CONSTANTS.applicationConstants.eidComplete;
        this.util.setSessionStorage(this.preQualObj);
        this.verifyUsers(users, index + 1);
      } else {
        this.loader = false;
        this.util.setSessionStorage(this.preQualObj);
        this.saveprequalData(this.preQualObj);
        this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      }
    }, (err) => {
      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    });
  }
  saveprequalData(prequalData) {
    this.util.saveJson(prequalData).subscribe((result) => {
    }, (err) => {
      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    }
    );
  }

}